<template>
    <div>
        <ul v-for="(dato, index) of datos" :key="index">
            <li v-for="(valor, index2) of dato.titulos" :key="index2">
                {{valor}} - {{dato.valor}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'datos-graficas',
    props:['datos'],
    data() {
        return {
            
        }
    },
}
</script>